import { render, staticRenderFns } from "./SubcontractorForm.vue?vue&type=template&id=6cfcf6e8&scoped=true"
import script from "./SubcontractorForm.vue?vue&type=script&lang=js"
export * from "./SubcontractorForm.vue?vue&type=script&lang=js"
import style0 from "./SubcontractorForm.vue?vue&type=style&index=0&id=6cfcf6e8&prod&lang=scss&scoped=true"
import style1 from "./SubcontractorForm.vue?vue&type=style&index=1&id=6cfcf6e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfcf6e8",
  null
  
)

export default component.exports